import React, { useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import { SitecoreContextReactContext } from '../../../utils/SitecoreContextReactContext';
import { canUseDOM, isChina, getGlobalDictionaryTerm, get, getPageThemeColors } from '../../../utils';
import { getUserCookie, getLatestUserCookie } from '../../Login/user_session';
import IconHeartLine from '../../../components/atoms/Icons/IconHeartLine';
import IconHeartFilled from '../../../components/atoms/Icons/IconHeartFilled';
import { syncTopPicks, getEmptyTopPicksStorage, getTopPicks, getTopPicksStorage, setTopPicksStorage, addTopPicks, removeTopPicks } from './top_picks_apis';
export const idConverter = id => {
  id = id.toLowerCase();
  if (id.length === 36) {
    return id;
  } else if (id.length === 32) {
    return `${id.substr(0, 8)}-${id.substr(8, 4)}-${id.substr(12, 4)}-${id.substr(16, 4)}-${id.substr(20)}`;
  } else if (id.length === 38) {
    return `${id.substr(1, 36)}`;
  }
};
const FavouriteBtn = _ref => {
  let {
    classes,
    itemId,
    callback,
    checkFavouriteButton,
    analyticsClick,
    componentPrimaryColor,
    componentPrimaryColorActive,
    multiplyButton = false,
    activeListOnSamePage,
    isListing = false,
    isSharedCh = false
  } = _ref;
  const additionalClasses = classes || '';
  const storageName = 'top-picks';
  const loginPopupCookieName = 'login_popup';
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const [connectedState, setConnectedState] = useState(false);
  const primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  const primaryActivePageThemeColor = get(sitecoreContext, 'themesOfPage.primary_active');
  const addToFavorites = getGlobalDictionaryTerm(sitecoreContext, 'addToFavorites') || 'add To Favorites';
  const removeFromFavorites = getGlobalDictionaryTerm(sitecoreContext, 'removeFromFavorites') || 'remove from Favorites';
  const identityGlobal = get(sitecoreContext, 'configuration.globalApi.identityGlobal') || 'https://replaceidentityGlobal';
  const clientId = get(sitecoreContext, 'configuration.globalApi.clientId') || 'replaceint2';
  const apiGlobal = get(sitecoreContext, 'configuration.globalApi.apiGlobal') || 'https://replaceapiGlobal';
  const clientSecret = get(sitecoreContext, 'configuration.globalApi.clientSecret') || 'replacesecret';
  const [isVdsite, setIsVdsite] = React.useState(true);
  React.useEffect(() => {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  const variables = componentPrimaryColor && !isListing ? {
    '--favorite-btn-primary-color': componentPrimaryColor,
    '--favorite-btn-active-primary-color': componentPrimaryColorActive
  } : {
    '--favorite-btn-primary-color': primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary,
    '--favorite-btn-active-primary-color': primaryActivePageThemeColor ? primaryActivePageThemeColor : getPageThemeColors(isVdsite).primary
  };
  let topPicksList = {
    list: []
  };
  const [active, setActive] = useState(false);
  let id;
  if (itemId) {
    id = idConverter(itemId);
  }
  const updateStateForFirstLoad = () => {
    let topPicks = getTopPicksStorage();
    let topPicksList = topPicks.list || [];
    if (topPicksList && topPicksList.length) {
      for (const item of topPicksList) {
        if (item.itemId === id) {
          setActive(true);
          break;
        } else if (active) {
          setActive(false);
        }
      }
    }
    if (topPicksList) {
      if (topPicksList.length) {
        if (canUseDOM) document.body.classList.add('has--favourites');
      }
    }
  };
  useEffect(() => {
    if (getUserCookie().login_status) {
      setTimeout(() => {
        updateStateForFirstLoad();
      }, 800);
    } else {
      updateStateForFirstLoad();
    }
  }, [itemId]);
  useEffect(() => {
    if (multiplyButton) {
      if (activeListOnSamePage) {
        if (activeListOnSamePage.includes(id)) {
          setActive(true);
        } else if (active) {
          setActive(false);
        }
      }
    }
  }, [activeListOnSamePage, multiplyButton]);

  // useEffect(() => {

  //   // toggleInner();
  //   setTimeout(() => {
  //     updateStateForFirstLoad();
  //   }, 1000);
  // }, [checkFavouriteButton]);
  if (canUseDOM) {
    const urlParams = new URLSearchParams(document.location.search);
    const isC = Boolean(urlParams.get('isChina') === 'true');
    if (isC) {
      return /*#__PURE__*/React.createElement(React.Fragment, null);
    }
  }
  const loginPopupCheck = () => {
    if (!getUserCookie().login_status) {
      const loginPopupCookie = Cookies.get(loginPopupCookieName);
      if (loginPopupCookie === undefined) {
        if (canUseDOM) {
          document.body.classList.add('lr-popup--open');
          const popup = document.querySelector('.lr-popup');
          if (popup) {
            const focusableInner = popup.querySelector('a, button, [tabindex="0"]');
            if (focusableInner) {
              focusableInner.focus();
            }
          }
        }
      }
    }
  };
  const topPicksAddition = id => {
    return new Promise(resolve => {
      if (getUserCookie().login_status) {
        getLatestUserCookie(identityGlobal, clientId, clientSecret).then(userCookie => {
          if (userCookie.login_status) {
            if (userCookie.error) {
              resolve(false);
            } else {
              addTopPicks(userCookie.access_token, [id], apiGlobal).then(state => {
                if (state.success) {
                  resolve(true);
                } else {
                  resolve(false);
                }
              });
            }
          } else {
            resolve(false);
          }
        });
      } else {
        resolve(false);
      }
    });
  };
  const topPicksRemoval = id => {
    return new Promise(resolve => {
      if (getUserCookie().login_status) {
        getLatestUserCookie(identityGlobal, clientId, clientSecret).then(userCookie => {
          if (userCookie.login_status) {
            if (userCookie.error) {
              resolve(false);
            } else {
              removeTopPicks(userCookie.access_token, [id], apiGlobal).then(state => {
                if (state.success) {
                  resolve(true);
                } else {
                  resolve(false);
                }
              });
            }
          } else {
            resolve(false);
          }
        });
      } else {
        resolve(false);
      }
    });
  };
  const addDisconnectedItems = (topPicksList, id) => {
    let foundInRemoved = false;
    topPicksList.removed = topPicksList.removed.filter(item => {
      if (item !== id) {
        return true;
      } else {
        foundInRemoved = true;
      }
    });
    if (!foundInRemoved) {
      topPicksList.added.push(id);
    }
    return topPicksList;
  };
  const removeDisconnectedItems = (topPicksList, id) => {
    let foundInAdded = false;
    topPicksList.added = topPicksList.added.filter(item => {
      if (item !== id) {
        return true;
      } else {
        foundInAdded = true;
      }
    });
    if (!foundInAdded) {
      topPicksList.removed.push(id);
    }
    return topPicksList;
  };
  const toggleBodyClass = list => {
    if (canUseDOM) {
      if (list && list.length) {
        document.body.classList.add('has--favourites');
      } else {
        document.body.classList.remove('has--favourites');
      }
    }
  };
  const toggleInner = () => {
    let topPicksList = getTopPicksStorage();
    if (active) {
      topPicksRemoval(id).then(status => {
        topPicksList.sync = status;
        topPicksList.list = topPicksList.list.filter(item => {
          return item.itemId === id ? false : true;
        });
        if (!status) {
          topPicksList = removeDisconnectedItems(topPicksList, id);
        }
        setTopPicksStorage(topPicksList);
        toggleBodyClass(topPicksList.list);
      });
    } else {
      topPicksAddition(id).then(status => {
        topPicksList.sync = status;
        topPicksList.list.push({
          itemId: id
        });
        if (!status) {
          topPicksList = addDisconnectedItems(topPicksList, id);
        }
        setTopPicksStorage(topPicksList);
        toggleBodyClass(topPicksList.list);
      });
    }
    setActive(!active);
    if (callback) {
      callback(id);
      setActive(true);
    }
  };

  // Toggle Fav State and add/remove in cookie
  const toggleFavourite = () => {
    loginPopupCheck();
    // callback(id)

    let topPicksList = getTopPicksStorage();
    if (topPicksList.sync) {
      toggleInner();
    } else {
      getLatestUserCookie(identityGlobal, clientId, clientSecret).then(userCookie => {
        if (userCookie.login_status) {
          syncTopPicks(userCookie.access_token, apiGlobal).then(result => {
            if (result) {
              getTopPicks(userCookie.access_token, apiGlobal).then(topPicks => {
                if (!topPicks.failed) {
                  setTopPicksStorage(getEmptyTopPicksStorage(topPicks));
                  toggleInner();
                } else {
                  toggleInner();
                }
              });
            } else {
              toggleInner();
            }
          });
        } else {
          toggleInner();
        }
      });
    }
  };
  if (!isChina()) {
    const titleForButton = active ? removeFromFavorites : addToFavorites;
    return /*#__PURE__*/React.createElement("button", {
      style: variables,
      className: `global-fav-button my-icon-white ${additionalClasses}`,
      "aria-label": titleForButton,
      onClick: () => {
        // if (callback) {

        // };
        if (analyticsClick) {
          analyticsClick(titleForButton, active);
        }
        toggleFavourite();
      },
      onKeyPress: event => {
        if (event.key === 'Enter' || event.key === 'NumpadEnter') {
          if (analyticsClick) {
            analyticsClick(titleForButton, active);
          }
          toggleFavourite();
        }
      }
    }, /*#__PURE__*/React.createElement("span", {
      hidden: true
    }, titleForButton), active ? /*#__PURE__*/React.createElement(IconHeartFilled, {
      className: "icon"
    }) : /*#__PURE__*/React.createElement(IconHeartLine, {
      className: "icon"
    }));
  }
  return /*#__PURE__*/React.createElement("div", null);
};
export default FavouriteBtn;